// If tracking has not completed setup before track event is fired, store it in a queue.
let trackEvents = [];
export const setupTracker = (trackEventFunction) => {
    window.trustEventTracker = trackEventFunction;
    // When setup is complete empty the queue and fire all track events.
    trackEvents.forEach((event) => trackEventFunction(event));
    // Reset the queue.
    trackEvents = [];
};
export const trackEvent = (event, source, elementType, vertical, target, size) => {
    const regEx = /\s+/g;
    const targetId = target === null || target === void 0 ? void 0 : target.replace(regEx, '-');
    const sourceId = source.replace(regEx, '-');
    const eventObject = event.object ? { object: event.object } : {
        object: {
            id: sourceId,
            name: source,
            type: 'UIElement',
            elementType: elementType,
            position: event.position,
            size,
        },
    };
    const targetObject = target
        ? {
            target: {
                id: targetId,
                type: 'Form',
                name: target,
            },
        }
        : undefined;
    const verticalObject = vertical || event.vertical
        ? {
            vertical: {
                ...vertical,
                ...event.vertical,
                '@type': 'MarketplaceVertical',
            },
        }
        : undefined;
    const trackObject = {
        ...event,
        ...targetObject,
        ...eventObject,
        ...verticalObject,
        ...{ experiments: event.experiments }
    };
    track(trackObject);
};
export const track = (event) => {
    if (window && (window === null || window === void 0 ? void 0 : window.trustEventTracker)) {
        window.trustEventTracker(event);
    }
    else {
        trackEvents.push(event);
    }
};
//# sourceMappingURL=trackPulse.js.map